import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { DualRingLoaderComponent } from './dualringloader.component'

@NgModule({
    imports: [CommonModule],
    declarations: [DualRingLoaderComponent],
    exports: [DualRingLoaderComponent],
})
export class DualRingLoaderModule {}
